module.exports = __webpack_public_path__ + "static/hero-bg-mobile-383c917e7df6e82da8114c7207c744db.jpg";